import React from 'react'
import './Experience.css'
import { Chip } from '@mui/material'
import JavascriptIcon from '@mui/icons-material/Javascript';
import StorageIcon from '@mui/icons-material/Storage';
import PsychologyIcon from '@mui/icons-material/Psychology';
import DataObjectIcon from '@mui/icons-material/DataObject';
import { MaterialUIIcon, GitIcon, PHPIcon, BootsrapIcon, CPlusPlusIcon, CSSIcon, HTMLIcon, JAVAIcon, MongoDBIcon, PhytonIcon, ReactIcon, VueIcon, TomcatIcon, NodejsIcon, BrainIcon, OpenAiIcon, TypeScriptIcon, TailwindIcon, AWSIcon, DockerIcon, GraphQLIcon, PostgreSQLIcon, AzureIcon, NextJsIcon } from '../Icons/Icons';


const styles = {
  whiteChip: {
    backgroundColor: 'white',
    color: "black",
    fontWeight: '500',
    padding:'10px'
  },
};
const skill_chips = {
  // AI/ML - Featured first
  open_ai: <Chip style={styles.whiteChip} icon={<OpenAiIcon />} label="OpenAI/LLMs" variant="filled" />,
  langchain: <Chip style={styles.whiteChip} icon={<PsychologyIcon />} label="LangChain" variant="filled" />,
  rag: <Chip style={styles.whiteChip} icon={<DataObjectIcon />} label="RAG" variant="filled" />,
  // Languages
  python: <Chip style={styles.whiteChip} icon={<PhytonIcon />} label="Python" variant="filled" />,
  javascript: <Chip style={styles.whiteChip} icon={<JavascriptIcon />} label="JavaScript" variant="filled" />,
  typescript: <Chip style={styles.whiteChip} icon={<TypeScriptIcon />} label="TypeScript" variant="filled" />,
  java: <Chip style={styles.whiteChip} icon={<JAVAIcon />} label="JAVA" variant="filled" />,
  cpp: <Chip style={styles.whiteChip} icon={<CPlusPlusIcon />} label="C++" variant="filled" />,
  // Frontend
  react: <Chip style={styles.whiteChip} icon={<ReactIcon />} label="React" variant="filled" />,
  nextjs: <Chip style={styles.whiteChip} icon={<NextJsIcon />} label="Next.js" variant="filled" />,
  vue: <Chip style={styles.whiteChip} icon={<VueIcon />} label="Vue" variant="filled" />,
  // Backend
  node: <Chip style={styles.whiteChip} icon={<NodejsIcon />} label="Node.js" variant="filled" />,
  graphql: <Chip style={styles.whiteChip} icon={<GraphQLIcon />} label="GraphQL" variant="filled" />,
  // Cloud & DevOps
  aws: <Chip style={styles.whiteChip} icon={<AWSIcon />} label="AWS" variant="filled" />,
  azure: <Chip style={styles.whiteChip} icon={<AzureIcon />} label="Azure" variant="filled" />,
  docker: <Chip style={styles.whiteChip} icon={<DockerIcon />} label="Docker" variant="filled" />,
  // Databases
  postgresql: <Chip style={styles.whiteChip} icon={<PostgreSQLIcon />} label="PostgreSQL" variant="filled" />,
  mongo: <Chip style={styles.whiteChip} icon={<MongoDBIcon />} label="MongoDB" variant="filled" />,
  sql: <Chip style={styles.whiteChip} icon={<StorageIcon />} label="SQL" variant="filled" />,
  // Tools & Others
  git: <Chip style={styles.whiteChip} icon={<GitIcon />} label="Git" variant="filled" />,
  problem_solving: <Chip style={styles.whiteChip} icon={<BrainIcon />} label="Problem Solving" variant="filled" />,
  // UI/Styling
  material: <Chip style={styles.whiteChip} icon={<MaterialUIIcon />} label="Material UI" variant="filled" />,
  tailwind: <Chip style={styles.whiteChip} icon={<TailwindIcon />} label="Tailwind CSS" variant="filled" />,
  css: <Chip style={styles.whiteChip} icon={<CSSIcon />} label="CSS" variant="filled" />,
  html: <Chip style={styles.whiteChip} icon={<HTMLIcon />} label="HTML" variant="filled" />,
  bootstrap: <Chip style={styles.whiteChip} icon={<BootsrapIcon />} label="Bootstrap" variant="filled" />,
  // Legacy (keeping for compatibility)
  php: <Chip style={styles.whiteChip} icon={<PHPIcon />} label="PHP" variant="filled" />,
  tomcat: <Chip style={styles.whiteChip} icon={<TomcatIcon />} label="Tomcat" variant="filled" />,
}
function SkillChips({ all, skills = [] }) {
  return (
    <>
      <p className='text-light skill-tilte' style={{ fontWeight: 500 }}>SKILLS</p>
      {all ? Object.keys(skill_chips).map(skill => skill_chips[skill]) : skills.map(skill => skill_chips[skill])}
    </>
  )
}

export default SkillChips